<div class="w-full h-full p-4 md:p-12 overflow-y-scroll hide-bar">
@if(dataParams.customActionsTop && dataParams.customActionsTop.length > 0){<div
    class="flex flex-wrap gap-4 place-content-end mb-4">
    @for (customAction of dataParams.customActionsTop; track $index) {
    <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary"
        (click)="generateCustomAction(customAction.component,null)">{{customAction.translateLabel ?
        t(customAction.label) : customAction.label}}</std-button>
    }
</div>}
   @if(!dataParams.customCard){ <std-card cardClass="h-fit mb-6" headerClass="bg-primary">
    <div header class="text-tertiary text-title">{{t('detail')}}</div>
    <div content class="flex items-center flex-wrap gap-[6%] lg:gap-[2%] lower-medium">
        <div *ngFor="let detail of dataParams.details" class="w-[47%] lg:w-[32%] mb-6"
            [ngClass]="{'opacity-50 pointer-events-none': !detail.editable}">
            @if(detail.type !== 'select' && detail.type !== 'image'){ <std-input customInputClass="custom-input"
                customLabel="label-input" [type]="detail.type" [(ngModel)]="myData[detail.element]"
                [label]="t('labels.'+detail.element)  + (detail.obligatory ? '*' : '') " labelPosition="top"
                [placeholder]="t('placeholders.'+detail.element)  + (detail.obligatory ? '*' : '') "> </std-input>
            }
            @if(detail.type == 'select'){
                <std-select [endpointData]="detail.selectDataEndpoint ?? ''" [filterable]="true" customLabel="label-input"
          customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
          (onChangeValue)="mangageSelect($event, detail)" [data]="
            listOfDataForSelects[detail.element] ?? detail.selectArray
          " [bindLabel]="detail.bindLabelSelect ?? 'label'" [bindValue]="detail.bindValueSelect ?? 'value'"
          customClassContaier="border-primary custom-select" [label]="
            t(
              'labels.' + (myData.label ? myData.label : detail.element)
            ) + (detail.obligatory ? '*' : '')
          " labelPosition="top" [placeholder]="
            t('labels.' + (myData.label ? myData.label : detail.element))
          " [currentValue]="
            getCurrentValue(
              myData[detail.element],
              listOfDataForSelects[detail.element],
              detail
            )
          "></std-select>
            }
            @if(detail.type == 'image'){

            <div class="flex items-center gap-4">
                @if(myData[(detail.tableElementToVisualize && detail.tableElementToVisualize.length > 0) ?
                detail.element +
                'ToVisualize' : detail.element]){
                <img class="max-h-[150px]"
                    [src]="baseUrl + '/'+ myData[(detail.tableElementToVisualize && detail.tableElementToVisualize.length > 0) ? detail.element + 'ToVisualize' : detail.element]">
                }
                <input class="h-fit"
                    [ngClass]="{'hidden': myData[(detail.tableElementToVisualize && detail.tableElementToVisualize.length > 0) ? detail.element + 'ToVisualize' : detail.element]}"
                    [id]=" 'file-'+detail.element" type="file" (change)="manageFiles($event,detail)"
                    [placeholder]="t('placeholders.'+detail.element)">
            </div>
            }

        </div>
        <div class="md:flex gap-4 place-content-center w-full">
            <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary w-full mb-4 md:mb-0 md:min-w-[200px]"
                (click)="resetToOriginal()">{{t('reset')}}</std-button>
            <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary w-full md:min-w-[200px]"
                (click)="editElement(t)">{{t('saveEdit')}}</std-button>
        </div>

        @if(dataParams.customActionsCard && dataParams.customActionsCard.length > 0){<div
            class="flex flex-wrap gap-4 place-content-center mt-4 mx-auto">
            @for (customAction of dataParams.customActionsCard; track $index) {
            <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                (click)="generateCustomAction(customAction.component,null)">{{customAction.translateLabel ?
                t(customAction.label) : customAction.label}}</std-button>
            }
        </div>}

    </div>
</std-card>}
        <div [ngClass]="{'hidden': !dataParams.customCard}" #customCardUniversalDetailsContainer id="custom-card-universal-details-container"></div>
    @if(!dataParams.customTabs){<std-tabs titleClass="border-primary text-title">
        <std-tab *ngFor="let tab of dataParams.tables" [title]="t(tab.name)" [active]="tab.active">
            <div class="flex flex-wrap gap-4 place-content-end mt-4">
                @for (customAction of tab.customActions; track $index) {
                    <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" (click)="generateCustomAction(customAction.component,null)"
                   >{{customAction.translateLabel ? t(customAction.label) : customAction.label}}</std-button>
                }
                @if(tab.canAddElement){<std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                    (click)="addSubElement(tab)">{{t('add')}} {{t(tab.customAddLabel ?tab.customAddLabel : tab.name)}}</std-button>} 
            </div>
            @if(tab.single){
            @for (tableCol of tab.table; track $index) {
            @if(tableCol.table && tablesData[tab.name]){<div>
                
                @if(tableCol.type !== 'select'){
                    <div [ngClass]="{'pointer-events-none opacity-35': !tableCol.editable}"><std-input customInputClass="custom-input" customLabel="label-input"
                    [type]="tableCol.type" [(ngModel)]="tablesData[tab.name][tableCol.element]"
                    [label]="t('labels.'+tableCol.element) + (tableCol.obligatory ? '*' : '')" labelPosition="top"
                    [placeholder]="t('placeholders.'+tableCol.element)"></std-input></div>}

                    @if(tableCol.type == 'select'){
                        <div [ngClass]="{'pointer-events-none opacity-35': !tableCol.editable}">
                        <std-select customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                        [bindLabel]="tableCol.bindLabelSelect ?? 'label'"
                        [bindValue]="tableCol.bindValueSelect ?? 'value'"
                        [data]="tableCol.selectDataEndpoint ? listOfDataForSubSelects[tableCol.element] : tableCol.selectArray"
                        customClassContaier="!border-primary custom-select"
                        (onChangeValue)="manageChangeValueSubSelectSingle(tableCol,$event,tab.name)"
                        [currentValue]="getCurrentValueForSubSelect(tableCol,subElementModalValue[tableCol.element])"
                        [label]="t('labels.'+tableCol.element) + (tableCol.obligatory ? '*' : '')" labelPosition="top"
                        [placeholder]="t('placeholders.'+tableCol.element)"></std-select></div>

                    }
            </div>}
            }
            @if(tab.canEditElement){<div class="ml-auto w-[200px] mt-4">
                <std-button buttonClass="w-full" (click)="subElementModalValue = tablesData[tab.name];currentTab = tab;isNewSubElement = true;confirmSubElement()" buttonClass="bg-primary focus:bg-primary hover:bg-primary">{{t('save')}}</std-button>
            </div>}
            }
            @if(!tab.single){<div class="mt-4"> <std-table class="hide-bar-all bg-secondary  fix-table" [tableTitle]="t(tab.name)"
                    [data]="tablesData[tab.name]" tableContainerClass="bg-secondary"
                    headerClass=" bg-primary focus:bg-primary hover:bg-primary">
                    @for (tableCol of tab.table; track $index) {
                    @if(tableCol.table && tableCol.type !== 'image'){
        
                    @if(!tableCol.translateValue){ <span stdoutTableColumn [label]="t(tableCol.element)"
                        [property]="tableCol.element"></span>}
                    @if(tableCol.translateValue){ <span stdoutTableColumn [label]="t(tableCol.element)">
                        <ng-template #dataTableCell let-item="item">
                            <div>{{t((tableCol.prefixTranslateValue ?? '') + item[tableCol.element])}}</div>
                        </ng-template>
                    </span>}
                    }
                    @if(tableCol.table && tableCol.type === 'image'){
                    <span stdoutTableColumn width="calc(100% - 28px)" [label]="t(tableCol.element)">
                        <ng-template #dataTableCell let-item="item">
                            <div class="flex items-end gap-5">
                                @if(item.image){<img class="max-h-[50px] mx-auto" [src]="endPointBackend  +'/' + item.image">
                                } </div>
                        </ng-template>
                    </span>
                    }
                    }
                    <span stdoutTableColumn width="calc(100% - 28px)" [label]="t('actions')">
                        <ng-template #dataTableCell let-item="item">
                            <div class="flex items-end gap-5">
                                @if(tab.canEditElement){ <std-button size="xs" type="primary"
                                    (click)="showEditSubElement(item,tab)"
                                    buttonClass="rounded-full size-[30px] bg-primary focus:bg-primary hover:bg-primary">
                                    <svg class="size-[14px] fill-white" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" />
                                    </svg>
                                </std-button>}
                                @if(tab.canDeleteElement){ <std-button size="xs" type="primary"
                                    (click)="showDeleteSubElement(item,tab)"
                                    buttonClass="rounded-full size-[30px] bg-primary focus:bg-primary hover:bg-primary">
                                    <svg class="size-[14px] fill-white" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 448 512">
                                        <path
                                            d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" />
                                    </svg>
                                </std-button>}
                                @if(tab.details) { <std-button size="xs" type="primary"
                                    buttonClass="rounded-full size-[30px] bg-primary focus:bg-primary hover:bg-primary">
                                    <svg class="size-[20px]" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g>
                                            <path class="fill-white"
                                                d="M10.0006 12.5004C11.3815 12.5004 12.5009 11.381 12.5009 10.0001C12.5009 8.61916 11.3815 7.49971 10.0006 7.49971C8.61966 7.49971 7.50021 8.61916 7.50021 10.0001C7.50021 11.381 8.61966 12.5004 10.0006 12.5004Z"
                                                fill="#2D2D2D" />
                                            <path class="fill-white"
                                                d="M19.1741 9.31995C18.1405 7.72151 16.7995 6.3637 15.2964 5.39299C13.6335 4.31799 11.7975 3.74963 9.98738 3.74963C8.32644 3.74963 6.69324 4.22424 5.13308 5.16018C3.54206 6.11448 2.10066 7.50862 0.848704 9.30354C0.70737 9.50639 0.629532 9.74669 0.62508 9.99388C0.620629 10.2411 0.689765 10.484 0.823704 10.6918C1.85534 12.3063 3.18308 13.666 4.66277 14.6235C6.32878 15.7028 8.12175 16.2496 9.98738 16.2496C11.812 16.2496 13.6518 15.686 15.3077 14.6199C16.81 13.6524 18.1483 12.2895 19.178 10.6778C19.3073 10.4748 19.3757 10.239 19.375 9.99828C19.3743 9.75761 19.3046 9.52218 19.1741 9.31995ZM10.0007 13.7496C9.25898 13.7496 8.53395 13.5297 7.91727 13.1176C7.30058 12.7056 6.81994 12.1199 6.53611 11.4347C6.25228 10.7495 6.17802 9.99548 6.32271 9.26805C6.46741 8.54062 6.82456 7.87243 7.34901 7.34798C7.87345 6.82354 8.54164 6.46638 9.26907 6.32169C9.9965 6.177 10.7505 6.25126 11.4357 6.53509C12.1209 6.81891 12.7066 7.29956 13.1187 7.91625C13.5307 8.53293 13.7507 9.25796 13.7507 9.99963C13.7495 10.9938 13.3541 11.947 12.6511 12.65C11.948 13.353 10.9949 13.7485 10.0007 13.7496Z"
                                                fill="#2D2D2D" />
                                        </g>
                                    </svg>
        
                                </std-button>}
                                @for (customTableAction of tab.customTableActions; track $index) {
                                    <std-button (click)="generateCustomAction(customTableAction.component,item)" size="xs" type="primary"
                                    buttonClass="rounded-full size-[30px] bg-primary focus:bg-primary hover:bg-primary text-medium !h-10" class="!h-10">
                                   <img [src]="customTableAction.icon" [class]="'size-[20px] ' + customTableAction.iconClass">
                                        
                                </std-button>  
                                }
        
                            </div>
                        </ng-template>
                    </span>
                </std-table>
                @if(tablesData[tab.name + 'Pagination']){<div class="mt-4">
                    <std-paginator (pageChange)="subTableChangePage(tab,$event)" [current]="tablesData[tab.name + 'Pagination'].currentPage"
                        [total]="tablesData[tab.name + 'Pagination'].totalPages">
                    <div class="h-full w-auto my-auto text-black" arrowLeft>
      <</div>
        <div arrowRight class="h-full w-auto my-auto text-black">
          >
        </div></std-paginator>
                </div>}
                
                </div>}
        </std-tab>
    </std-tabs>}
    <div #customTabsUniversalDetailsContainer id="custom-tabs-universal-details-container" [ngClass]="{'hidden': !dataParams.customTabs}"></div>
    <std-modal  cardClass="!max-w-[90vw]" headerClass="bg-primary" [show]="showModelDelete" [closeOnOutside]="false"
        (close)="showModelDelete=false">
        <div class="text-tertiary text-large" header>{{t('modal.delete')}}</div>
        <div content>
            <div class="text-primary text-medium">{{t('modal.confirmation')}}</div>
            <div class="mt-4 md:flex gap-4">
                <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary mb-4 md:mb-0" (click)="showModelDelete = false"
                    class="md:w-[200px]">{{t('modal.cancel')}}</std-button>
                <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" (click)="deleteSubElement()"
                    class="md:w-[200px]">{{t('modal.confirm')}}</std-button>
            </div>
        </div>
    </std-modal>
    <std-modal  cardClass="!max-w-[90vw] w-[90vw]" *ngIf="showModalSubElement" headerClass="bg-primary" [show]="showModalSubElement"
        [closeOnOutside]="false" (close)="showModalSubElement=false">
        <div class="text-tertiary text-large" header>{{t(isNewSubElement ? 'add' : 'modal.edit')}}</div>
        <div content class="custom-scroll grid gap-4">

            @for (dataForm of currentTab.table; track $index) {
            @if(isNewSubElement && dataForm.editable && dataForm.type !== 'select' && dataForm.type !== 'image'&& dataForm.type !== 'time'){<std-input customInputClass="custom-input" customLabel="label-input" [type]="dataForm.type"
                [(ngModel)]="subElementModalValue[dataForm.element]"
                [label]="t('labels.'+dataForm.element) + (dataForm.obligatory ? '*' : '')" labelPosition="top"
                [placeholder]="t('placeholders.'+dataForm.element)"></std-input>}
                @if(dataForm.creation && dataForm.type !== 'select' && dataForm.type === 'image'){
                    <input type="file" (change)="manageFiles($event,dataForm)" [placeholder]="t('placeholders.'+dataForm.element)">
                    }
            @if(!isNewSubElement && dataForm.creation && dataForm.type !== 'select' && dataForm.type !== 'image'&& dataForm.type !== 'time'){<std-input customInputClass="custom-input" customLabel="label-input" [type]="dataForm.type"
                [(ngModel)]="subElementModalValue[dataForm.element]"
                [label]="t('labels.'+dataForm.element) + (dataForm.obligatory ? '*' : '')" labelPosition="top"
                [placeholder]="t('placeholders.'+dataForm.element)"></std-input>}
            @if(isNewSubElement && dataForm.editable && dataForm.type === 'select' && dataForm.type !== 'image'&& dataForm.type !== 'time'){
                <std-select customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                [bindLabel]="dataForm.bindLabelSelect ?? 'label'"
                [bindValue]="dataForm.bindValueSelect ?? 'value'"
                [data]="dataForm.selectDataEndpoint ? listOfDataForSubSelects[dataForm.element] : dataForm.selectArray"
                customClassContaier="!border-primary custom-select"
                (onChangeValue)="manageChangeValueSubSelect(dataForm,$event)"
                [currentValue]="getCurrentValueForSubSelect(dataForm,subElementModalValue[dataForm.element])"
                [label]="t('labels.'+dataForm.element) + (dataForm.obligatory ? '*' : '')" labelPosition="top"
                [placeholder]="t('placeholders.'+dataForm.element)"></std-select>
            }
            @if(!isNewSubElement && dataForm.creation && dataForm.type === 'select' && dataForm.type !== 'image'&& dataForm.type !== 'time'){
                <std-select customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                [bindLabel]="dataForm.bindLabelSelect ?? 'label'"
                [bindValue]="dataForm.bindValueSelect ?? 'value'"
                [data]="dataForm.selectDataEndpoint ? listOfDataForSubSelects[dataForm.element] : dataForm.selectArray"
                customClassContaier="!border-primary custom-select"
                (onChangeValue)="manageChangeValueSubSelect(dataForm,$event)"
                [currentValue]="getCurrentValueForSubSelect(dataForm,subElementModalValue[dataForm.element])"
                [label]="t('labels.'+dataForm.element) + (dataForm.obligatory ? '*' : '')" labelPosition="top"
                [placeholder]="t('placeholders.'+dataForm.element)"></std-select>
            }



            @if(((!isNewSubElement && dataForm.creation) || (isNewSubElement && dataForm.editable)) && dataForm.type ===
        'time'){
    <div (click)="specialModalTimeToShow =   'time-'+dataForm.element"> 
      
          @if (!isNewSubElement || subElementModalValue[dataForm.element]){<std-input
          customInputClass="custom-input"
          customLabel="label-input"
          class="pointer-events-none"
          [type]="dataForm.type"
          [(ngModel)]="subElementModalValue[dataForm.element]"
          [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          "
          labelPosition="top"
          [placeholder]="
            t(
              'placeholders.' +
                (dataForm.placeholder ? dataForm.placeholder : dataForm.element)
            )
          "
        ></std-input>}

     @if (isNewSubElement && !subElementModalValue[dataForm.element]){<std-input
          customInputClass="custom-input"
          customLabel="label-input"
          class="pointer-events-none"
          [type]="dataForm.type"
          [value]="subElementModalValue[dataForm.element]"
          [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          "
          labelPosition="top"
          [placeholder]="
            t(
              'placeholders.' +
                (dataForm.placeholder ? dataForm.placeholder : dataForm.element)
            )
          "
        ></std-input>}</div> 
        @if(specialModalTimeToShow === 'time-'+dataForm.element){
          <div class="flex h-screen  !w-screen bg-black !bg-opacity-35 place-content-center items-center fixed top-0 left-0 z-[9999]">
            <std-time-picker [showClock]="dataParams.showClock" [use24h]="dataParams.use24h" [startingTime]="!isNewSubElement ? subElementModalValue[dataForm.element] : '00:00'" (changeDate)="tempVariable = $event.formattedTime">
              <div footer class="mt-6 flex gap-4">
               <div class="w-full"> <std-button
                  buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                  (click)="specialModalTimeToShow = ''"
                  class="w-[200px]"
                  >{{ t("modal.cancel") }}</std-button
                ></div>
              <div class="w-full">  <std-button [ngClass]="{'opacity-35 pointer-events-none':isNewSubElement && !tempVariable }"
                  buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                  (click)="subElementModalValue[dataForm.element] = tempVariable ? tempVariable : '00:00';tempVariable=null;specialModalTimeToShow = null"
                  class="w-[200px]"
                  >{{ t("modal.confirm") }}</std-button
                ></div>
              </div>
            </std-time-picker>
          </div>
        }
        }
            }
            <div class="mt-6 md:flex gap-4">
                <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary mb-4 md:mb-0"
                    (click)="showModalSubElement = false" class="md:w-[200px]">{{t('modal.cancel')}}</std-button>
                <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" (click)="confirmSubElement()"
                    class="md:w-[200px]">{{t('modal.confirm')}}</std-button>
            </div>
        </div>
    </std-modal>
</div>